import React from "react";
import PropTypes from "prop-types";
// Material imports
import { useTheme } from "@mui/styles";
//Limitless imports
import { UserAvatar } from "../../../../../../customer/components";
const ExpertAvatar = ({
  dialogue,
  message
}) => {
  const {
    author,
    userId
  } = dialogue;
  const {
    expertAuthors
  } = message;
  const theme = useTheme();
  const thumbnail = expertAuthors[userId] ? expertAuthors[userId].thumbnail : null;
  if (!message.conversationState.showExpertThumbnail || !author) {
    //add default expert
    return /*#__PURE__*/React.createElement("div", null);
  }
  return /*#__PURE__*/React.createElement(UserAvatar, {
    author: author,
    thumbnail: thumbnail,
    theme: theme
  });
};
export default ExpertAvatar;
ExpertAvatar.propTypes = {
  message: PropTypes.object.isRequired,
  dialogue: PropTypes.object.isRequired
};